//extracted by mini-css-extract-plugin
export default {"mainContainer":"styles_mainContainer__08S5w"};;